import { memo, useCallback, useMemo } from "react";

import type { RoomStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";
import { StockDailyItemMobile } from "@/components/features/items/stock/_shared/components/mobile/daily-item";

import { useRoomStockTablePresenter } from "./hooks/use-room-table-presenter";

import type { RoomStockDiffStore } from "../../../../../model/usecase/use-create-form-model/room-stock-diff-store";

type Props = {
	serverModel: RoomStock_StockManagementQuery;
	roomStockDiffStore: RoomStockDiffStore;
	selectedItemIDs: string[];
};

export const RoomStockTableMobile = memo(({ serverModel, roomStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredViewModel } = useRoomStockTablePresenter({
		serverModel,
		selectedItemIDs,
	});

	const { items } = filteredViewModel;

	const onSetStock = useCallback(
		(roomID: string, date: string) => (isAvailable: boolean, remainNum: number) => {
			roomStockDiffStore.put({ roomID, date, isAvailable, remainNum });
		},
		[roomStockDiffStore],
	);

	/**
	 * 在庫一覧を表示するか
	 */
	const canSshowStockList = useMemo(() => items.length > 0, [items.length]);

	return (
		<div>
			{canSshowStockList ? (
				<div>
					{items.map((item) => {
						const key = item.roomID;

						return (
							<div key={key} className="space-y-4">
								{item.stocks.map((stock, idx) => {
									return (
										<StockDailyItemMobile
											key={`${key}-${stock.date}-${idx}`}
											stockDailyItem={stock}
											onSetStock={onSetStock(item.roomID, stock.date)}
										/>
									);
								})}
							</div>
						);
					})}
				</div>
			) : (
				<BlankContentForList content="表示する部屋がありません。" />
			)}
		</div>
	);
});

RoomStockTableMobile.displayName = "RoomStockTableMobile";
